<template>
    <div class="box-page">
        <i-modal ref="modalFollowUp" class="modal-small" :closeable="false">
            <template v-slot:title>
                <div class="modal-title pl-3 font-size-12 font-size-sm-10 font-weight-bold">Follow Up {{ followupModalNumber }}</div>
            </template>
            <template v-slot:body>
                <div class="modal-body pt-0">
                    <div class="col-12 pl-0 pr-0 d-flex flex-wrap justify-content-center">
                        <div class="col-12 col-md-12 mb-2 font-size-11">
                            <div class="col-12 col-md-12 font-weight-bold">
                                Nama
                            </div>
                            <div class="col-12 col-md-12">{{ detailFollowUp.prospective_member_name }}</div>
                        </div>
                        <div class="col-12 col-md-12 mb-2 font-size-11">
                            <div class="col-12 col-md-12 font-weight-bold">
                                Nomor Handphone
                            </div>
                            <div class="col-12 col-md-12">{{ detailFollowUp.prospective_member_mobilephone }}</div>
                        </div>
                        <div class="col-12 col-md-12 mb-2 font-size-11">
                            <div class="col-12 col-md-12 font-weight-bold mb-1">
                                Teks Follow Up
                            </div>
                            <div class="col-12 col-md-12">
                                <textarea v-model="detailFollowUp.prospective_member_followup_message"
                                    class="form-control form-control-sm box-blue rounded-cus font-size-sm-10" rows="5">
                                </textarea>
                            </div>
                        </div>
                        <!-- <div class="col-12 col-md-12 text-center">
                        </div> -->
                    </div>
                    <div class="col-12 pl-0 pr-0 mt-3 d-flex justify-content-center justify-content-md-end">
                        <button class="col-3 btn btn-outline-danger d-flex justify-content-center rounded-cus"
                            @click="$refs.modalFollowUp.modalHide()">
                            <span class="font-size-11"><i class="fas fa-times"></i></span>
                            <div class="font-size-11 pl-2">Batal</div>
                        </button>
                        <button class="col-3 btn btn-blue d-flex d-flex justify-content-center rounded-cus ml-3" @click="saveFollowUp">
                            <span class="font-size-11"><i class="fas fa-check"></i></span>
                            <div class="font-size-11 pl-2">Simpan</div>
                        </button>
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <div class="footer-modal">
                    <div></div>
                </div>
            </template>
        </i-modal>

        <i-modal ref="modalAlert" class="modal-small">
            <template v-slot:header>
                <div></div>
            </template>
            <template v-slot:body>
                <AlertModal :title="alertTitle" :message="alert" type="alert" :success="isSuccess" @remove="removeAlert" />
            </template>
            <template v-slot:footer>
                <div class="footer-modal">
                    <div></div>
                </div>
            </template>
        </i-modal>

        <div class="col-12 pl-0 pr-0">
            <div class="col-12 pl-0 pr-0 d-md-flex flex-column">
                <div class="col-12 col-md-12 pl-0 pr-0 pr-md-3 d-flex flex-row">
                    <div class="col-12 pl-2 pr-2 pl-md-3 pr-md-3 bg-white rounded-cus cus-box-shadow mr-3">
                        <div class="col-12 pt-3 pb-3 pl-2 pr-2 filter-title cursor-pointer" data-toggle="collapse" data-target="#filterReport"
                            @click="toggleFilter" :class="tfilter == true ? 'active' : ''">
                            <div class="col-6 pl-0 mt-auto mb-auto">
                                <div class="col-12 pl-0 pr-0 font-size-10"><span class="mr-2"><i class="fas fa-filter"></i></span>Filter</div>
                            </div>
                        </div>
                        <div id="filterReport" class="collapse">
                            <div class="col-12 pb-3 pl-2 pr-2 font-size-10 bg-white">
                                <div class="col-12 pt-2 pl-0 pr-0 d-flex">
                                    <div class="col-5 col-lg-3 pl-0 pt-1 font-size-sm-9 d-none d-md-block">Tanggal</div>
                                    <div class="col-12 col-md-7 col-lg-5 pl-0 pr-0 pr-md-2 d-flex">
                                        <div class="col-6 pl-0 pr-2">
                                            <datetime input-id="tanggalAwal" :max-datetime="maxDate"
                                                :min-datetime="new Date('2025-01-24').toISOString()" class="theme-purple"
                                                input-class="col-12 pt-1 pb-1 border rounded-cus color-black box-purple font-size-9"
                                                placeholder="Dari Tanggal" v-model="tanggalAwal"></datetime>
                                        </div>
                                        <div class="col-6 pl-0 pr-0">
                                            <datetime input-id="tanggalAkhir" :max-datetime="today" :min-datetime="minDate" class="theme-purple"
                                                input-class="col-12 pt-1 pb-1 border rounded-cus color-black box-purple font-size-9"
                                                placeholder="Sampai Tanggal" v-model="tanggalAkhir"></datetime>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 pl-0 pr-0 pt-2 d-flex">
                                    <div class="col-5 col-lg-3 pl-0 pt-1 font-size-sm-9 d-none d-md-block">Kode Transaksi</div>
                                    <div class="col-12 col-md-7 col-lg-5 pl-0 pr-0 pr-md-2 d-flex">
                                        <input v-model="kode.value"
                                            class="col-12 font-size-9 form-control form-control-sm border rounded-cus box-purple" type="text"
                                            placeholder="Kode Transaksi">
                                    </div>
                                </div>
                                <div class="col-12 pl-0 pr-0 pt-2 d-flex">
                                    <div class="col-5 col-lg-3 pl-0 pt-1 font-size-sm-9 d-none d-md-block">Nama</div>
                                    <div class="col-12 col-md-7 col-lg-5 pl-0 pr-0 pr-md-2 d-flex">
                                        <input v-model="name.value"
                                            class="col-12 font-size-9 form-control form-control-sm border rounded-cus box-purple" type="text"
                                            placeholder="Nama Pembeli">
                                    </div>
                                </div>
                                <div class="col-12 pl-0 pr-0 pt-2 d-flex">
                                    <div class="col-5 col-lg-3 pl-0 pt-1 font-size-sm-9 d-none d-md-block">Nomor Handphone</div>
                                    <div class="col-12 col-md-7 col-lg-5 pl-0 pr-0 pr-md-2 d-flex">
                                        <input v-model="mobilephone.value"
                                            class="col-12 font-size-9 form-control form-control-sm border rounded-cus box-purple" type="text"
                                            placeholder="Nomor Handphone">
                                    </div>
                                </div>
                                <div class="col-12 pl-0 pr-0 pt-2 d-flex flex-wrap">

                                    <div class="col-5 col-lg-3 pl-0 pt-1 font-size-sm-9 d-none d-md-block">Status</div>
                                    <div class="col-12 col-md-7 col-lg-5 pl-0 pr-0 pr-md-2 d-flex">
                                        <select class="form-control form-control-sm font-size-9 box-purple text-gray rounded-cus"
                                            v-model="followup.value">
                                            <option value="" disabled>Status Follow Up</option>
                                            <option v-for="filter in followupStatusOptions" :key="filter.value" :value="filter.value">{{
                                                filter.value }}
                                                - {{ filter.text }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-5 d-lg-none"></div>
                                    <div class="col-12 col-md-7 col-lg-4 d-flex pl-0 pl-lg-3 pr-0 pr-lg-3 pt-3 pt-lg-0">
                                        <div class="col-6 pl-0 pr-2 pr-md-3">
                                            <button class="col-12 pt-1 pb-1 btn btn-outline-danger rounded-cus no-box-focus" @click="reset"><span
                                                    class="font-size-9">Reset</span></button>
                                        </div>
                                        <div class="col-6 pl-0 pr-0 pr-md-2 pr-lg-3">
                                            <button class="col-12 pt-1 pb-1 btn btn-blue rounded-cus no-box-focus" @click="cari"><span
                                                    class="font-size-9">Cari</span></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 d-flex pl-0 pr-0 pr-md-3  flex-column flex-md-row">
                    <div class="col-12 col-md-12 pl-2 pr-2 pl-md-3 pr-md-3 bg-white rounded-cus cus-box-shadow mt-3 pb-1">
                        <div class="col-12 pt-3 pb-3 pl-2 pr-2 d-flex">
                            <div class="col-8 col-md-6 pl-0 pb-1 mt-auto mb-auto">
                                <div class="col-12 pl-0 pr-0 font-size-sm-11">List Follow Up - Calon Member</div>
                            </div>
                        </div>
                        <div class="col-12 pl-0 pr-0 overflow-auto">
                            <div class="col-12 mt-3 pl-2 pr-2 pb-3 d-flex font-size-10">
                                <div class="col-4 col-md-3 col-lg-2 pl-0">Kode Transaksi</div>
                                <div class="col-4 col-md-4 col-lg-2 pl-0">Nama</div>
                                <div class="col-5 col-md-4 col-lg-3 pl-0">Produk</div>
                                <div class="col-3 col-md-3 col-lg-2 pl-0">Nomor HP</div>
                                <div class="col-4 col-md-3 col-lg-2 pl-0">Catatan</div>
                                <div class="col-4 col-md-4 col-lg-2 pl-0 text-center">Follow Up</div>
                                <div class="col-4 col-md-3 col-lg-2 pl-0 text-center">Aksi</div>
                            </div>
                            <div class="col-12 pl-2 pr-2 d-flex">
                                <div class="col-12 border-bottom d-none d-md-block"></div>
                                <div class="col-12 border-bottom d-none d-md-block d-lg-none"></div>
                                <div class="col-3 border-bottom d-none d-lg-block"></div>
                            </div>
                            <div v-show="prospectiveMember.length == 0">
                                <div class="col-12 pt-3 pl-2 pr-2" v-for="(index) in 5" :key="index">
                                    <vcl :width='300' :height='15' class="border-bottom">
                                        <rect x="1" y="2" rx="2" ry="2" width="40" height="7" />
                                        <rect x="50" y="2" rx="2" ry="2" width="70" height="7" />
                                        <rect x="125" y="2" rx="2" ry="2" width="50" height="7" />
                                        <rect x="125" y="2" rx="2" ry="2" width="50" height="7" />
                                        <rect x="185" y="2" rx="2" ry="2" width="40" height="7" />
                                        <rect x="185" y="2" rx="2" ry="2" width="40" height="7" />
                                        <rect x="240" y="2" rx="2" ry="2" width="40" height="7" />
                                        <!-- <rect x="1" y="25" rx="2" ry="2" width="28" height="7" />
                                        <rect x="1" y="35" rx="2" ry="2" width="35" height="7" />
                                        <rect x="100" y="18" rx="2" ry="2" width="7" height="7" />
                                        <rect x="110" y="18" rx="2" ry="2" width="28" height="7" />
                                        <rect x="230" y="18" rx="2" ry="2" width="35" height="7" />
                                        <rect x="284" y="19" rx="2" ry="2" width="9" height="9" />
                                        <rect x="284" y="3" rx="2" ry="2" width="9" height="9" /> -->
                                    </vcl>
                                </div>
                            </div>
                            <div class="col-12 pl-0 pr-0" v-if="prospectiveMember == 'error'">
                                <div class="col-12 pt-3 pb-3 text-center">
                                    <div class="col-6 col-md-4 ml-auto mr-auto">
                                        <img class="img-fluid" src="/assets/report/ilustrasi-data-kosong-report.png">
                                    </div>
                                    <div class="font-size-11 pt-1">Data tidak tersedia!</div>
                                </div>
                            </div>
                            <div class="col-12 pl-0" v-else>
                                <div class="col-12 pt-3 pl-2 pr-2 pb-3 d-flex font-size-10 align-items-center"
                                    v-for="(value, index) in prospectiveMember" :key="index">
                                    <div class="col-4 col-md-3 col-lg-2 pl-0">{{ value.prospective_member_trx_code }}</div>
                                    <div class="col-4 col-md-4 col-lg-2 pl-0">{{ value.prospective_member_name }}</div>
                                    <div class="col-5 col-md-4 col-lg-3 pl-0" v-html="productMemberList(value.product)"></div>
                                    <div class="col-3 col-md-3 col-lg-2 pl-lg-0">{{ value.prospective_member_mobilephone }}</div>
                                    <div class="col-4 col-md-3 col-lg-2 pl-lg-0">{{ value.prospective_member_note }}</div>
                                    <div class="col-4 col-md-4 col-lg-2 pl-0 text-center font-size-11">
                                        <div class="col-12 pr-0 pl-4 d-flex justify-content-center">
                                            <div class="btn rounded-circle cursor-pointer mr-2 color-white"
                                                :class="value.prospective_member_followup_status > 0 ? 'btn-blue' : 'btn-gray'"
                                                @click="showModalFollowUp(value, 1)">
                                                1</div>
                                            <div class="btn rounded-circle cursor-pointer mr-2 color-white"
                                                :class="value.prospective_member_followup_status > 1 ? 'btn-blue' : 'btn-gray'"
                                                @click="showModalFollowUp(value, 2)">2</div>
                                            <div class="btn rounded-circle cursor-pointer mr-2 color-white"
                                                :class="value.prospective_member_followup_status > 2 ? 'btn-blue' : 'btn-gray'"
                                                @click="showModalFollowUp(value, 3)">3</div>
                                            <div class="btn rounded-circle cursor-pointer mr-2 color-white"
                                                :class="value.prospective_member_followup_status > 3 ? 'btn-blue' : 'btn-gray'"
                                                @click="showModalFollowUp(value, 4)">4</div>
                                            <div class="btn rounded-circle cursor-pointer mr-2 color-white"
                                                :class="value.prospective_member_followup_status > 4 ? 'btn-blue' : 'btn-gray'"
                                                @click="showModalFollowUp(value, 5)">5</div>
                                        </div>
                                    </div>
                                    <div class="col-5 col-md-4 pl-md-4 col-lg-2 pl-lg-4 d-flex flex-row justify-content-center">
                                        <!-- <button class="btn btn-blue btn-sm rounded-cus no-box-focus font-size-10 mr-2">
                                            <i class="fas fa-people-arrows mr-2"></i>Update</button> -->
                                        <button v-if="value.prospective_member_followup_status > 0" class="btn btn-whatsapp btn-sm rounded-cus no-box-focus font-size-10" @click="sendWA(value)">
                                            <i class="fab fa-whatsapp mr-2"></i>Chat dengan WhatsApp</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 pl-2 pr-2">
                            <div class="col-12 border-bottom"></div>
                        </div>
                        <div class="col-12 pt-3 pl-2 pr-2 text-center">
                            <i-pagination :limit='limit' @changeLimit="changeLimit($event)" :pagination='pagination' @gotoPage="gotoPage($event)"
                                @refresh="refresh($event)"></i-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IPagination from '@/components/IPagination.vue';
import IModal from '@/components/IModal.vue';
import AlertModal from '@/components/elements/alert/AlertModal.vue';

import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import moment from 'moment';

export default {
    components: {
        IModal,
        AlertModal,
        IPagination,
    },
    name: 'Report',
    data() {
        return {
            confirmMessage: 'Apakah anda yakin melakukan proses ini?',
            tanggalAwal: "",
            tanggalAkhir: "",
            tfilter: false,
            today: new Date().toISOString(),
            limit: 10,
            tanggal: {
                value: '',
                comparison: 'bet',
                type: 'date',
                field: 'prospective_member_input_datetime'
            },
            kode: {
                value: '',
                comparison: 'LIKE',
                type: 'string',
                field: 'prospective_member_trx_code'
            },
            name: {
                value: '',
                comparison: 'LIKE',
                type: 'string',
                field: 'prospective_member_name'
            },
            mobilephone: {
                value: '',
                comparison: '=',
                type: 'string',
                field: 'prospective_member_mobilephone'
            },
            followup: {
                value: '',
                comparison: '=',
                type: 'string',
                field: 'prospective_member_followup_status'
            },
            params: {},
            rangeLaporan: '',
            page: 1,
            followupModalNumber: ''
        }
    },
    methods: {
        ...mapActions('followupList', ['getFollowUp', 'updateFollowUp']),
        ...mapActions('commonList', ['getFollowupStatus']),
        ...mapMutations('followupList', ['konfirmasiSukses', 'setAlert', 'setSuccess']),

        gotoPage(val) {
            this.page = val
            if (this.params) {
                this.getFollowUp({ params: this.params, page: this.page, limit: this.limit })
            } else {
                this.getFollowUp({ page: this.page, limit: this.limit })
            }
        },
        refresh(val) {
            this.page = val
            if (this.params) {
                this.getFollowUp({ params: this.params, page: this.page, limit: this.limit })
            } else {
                this.getFollowUp({ page: this.page, limit: this.limit })
            }
        },
        changeLimit(val) {
            this.page = 1
            this.limit = val
            if (this.params) {
                this.getFollowUp({ params: this.params, page: this.page, limit: this.limit })
            } else {
                this.getFollowUp({ page: this.page, limit: this.limit })
            }
        },
        cari() {
            this.params = []
            this.page = 1
            if (!this.tanggalAkhir) {
                this.tanggalAkhir = this.tanggalAwal
            }
            if (this.tanggalAkhir == this.tanggalAwal) {
                this.rangeLaporan = moment(this.tanggalAwal).format('Do MMMM YYYY')
            } else {
                this.rangeLaporan = moment(this.tanggalAwal).format('Do MMMM YYYY') + ' s.d ' + moment(this.tanggalAkhir).format('Do MMMM YYYY')
            }
            if (this.tanggalAwal && this.tanggalAkhir) {
                this.tanggal.value = moment(this.tanggalAwal).format('YYYY-MM-DD') + "::" + moment(this.tanggalAkhir).format('YYYY-MM-DD')
                this.params.push(this.tanggal)
            } else {
                this.rangeLaporan = ''
            }
            if (this.kode.value) {
                this.params.push(this.kode)
            }
            if (this.name.value) {
                this.params.push(this.name)
            }
            if (this.mobilephone.value) {
                this.params.push(this.mobilephone)
            }
            if (this.followup.value !== '') {
                this.params.push(this.followup)
            }
            this.getFollowUp({ params: this.params, page: this.page, limit: this.limit })
        },
        reset() {
            this.kode.value = ''
            this.name.value = ''
            this.mobilephone.value = ''
            this.followup.value = ''
            this.tanggal.value = ''
            this.rangeLaporan = ''
            this.tanggalAwal = ''
            this.tanggalAkhir = ''
            this.page = 1
            this.params = []
            this.getFollowUp({ params: this.params, page: this.page, limit: this.limit })
        },
        showModalFollowUp(value, followUp) {
            this.followupModalNumber = followUp
            this.detailFollowUp = value
            if(this.detailFollowUp.prospective_member_followup_status == followUp){
                this.detailFollowUp.prospective_member_followup_message = this.detailFollowUp.prospective_member_followup_message
            } else {
                this.detailFollowUp.prospective_member_followup_message = this.followupStatus[followUp]
            }
            this.$refs.modalFollowUp.modalShow()
        },
        async saveFollowUp() {
            this.$refs.modalFollowUp.modalHide()
            let payload = {
                code: this.detailFollowUp.prospective_member_trx_code,
                status: this.followupModalNumber,
                message: this.detailFollowUp.prospective_member_followup_message,
            }

            await this.updateFollowUp(payload).then((res) => {
                this.setSuccess(res)
                this.getFollowUp({ params: this.params, page: this.page, limit: this.limit })
            }).catch((err) => {
                this.setSuccess(false)
                this.setAlert(err.data.message || 'Terjadi kesalahan pada sistem.')
            })
        },
        toggleFilter() {
            if (!this.tfilter) {
                this.tfilter = true;
            } else {
                this.tfilter = false;
            }
        },
        removeAlert() {
            this.setAlert('')
        },
        sendWA(value) {
            let phoneNumber = value.prospective_member_mobilephone.replace(/[^0-9]/g, '');
            let countryCode = '62'; // Ganti dengan kode negara yang sesuai
            if (phoneNumber.startsWith('0')) {
                phoneNumber = countryCode + phoneNumber.substring(1);
            } else if (!phoneNumber.startsWith(countryCode)) {
                phoneNumber = countryCode + phoneNumber;
            }
            let message = encodeURIComponent(`${value.prospective_member_followup_message}`);
            let waLink = `https://wa.me/${phoneNumber}?text=${message}`;
            window.open(waLink, '_blank');
        },
        productMemberList(product){
            let list = '';
            product.forEach((value) => {
                list += value.product_quantity + 'x  ' + value.product_name + '<br> '
            })
            return list.substring(0, list.length - 2)
        }
    },
    computed: {
        // ...mapState('reportList', ['dataSalesReport', 'productSelling', 'dataProduct', 'dataSummary', 'pagination']),
        ...mapState('followupList', ['prospectiveMember', 'pagination', 'alert', 'isSuccess', 'alertTitle', 'konfirmResponse']),
        ...mapState('commonList', ['followupStatus']),
        ...mapState('auth', ['userData']),
        ...mapGetters('auth', ['isAuth']),

        followupStatusOptions() {
            let options = []
            this.followupStatus.forEach((value, index) => {
                options.push({ value: index, text: value })
            });
            return options
        },
        minDate() {
            var date = new Date().toISOString()
            if (this.tanggalAwal) {
                date = new Date(this.tanggalAwal).toISOString()
            } else {
                date = new Date("2025-01-24").toISOString()
            }
            return date
        },
        maxDate() {
            var date = new Date().toISOString()
            if (this.tanggalAkhir) {
                date = new Date(this.tanggalAkhir).toISOString()
            }
            return date
        }
    },
    created() {
        this.$store.dispatch('setPageTitle', 'List Follow Up - Calon Member');
        this.params = []
        if (!this.tanggalAkhir) {
            this.tanggalAkhir = this.tanggalAwal
        }
        if (this.tanggalAkhir == this.tanggalAwal) {
            this.rangeLaporan = moment(this.tanggalAwal).format('Do MMMM YYYY')
        } else {
            this.rangeLaporan = moment(this.tanggalAwal).format('Do MMMM YYYY') + ' s.d ' + moment(this.tanggalAkhir).format('Do MMMM YYYY')
        }
        if (this.tanggalAwal && this.tanggalAkhir) {
            this.tanggal.value = moment(this.tanggalAwal).format('YYYY-MM-DD') + "::" + moment(this.tanggalAkhir).format('YYYY-MM-DD')
            this.params.push(this.tanggal)
        } else {
            this.rangeLaporan = ''
        }
        this.getFollowUp({ params: this.params, page: this.page, limit: this.limit })
        this.getFollowupStatus()
        // this.getProduct({ params: [], page: this.page, limit: 1000 })
    },

    watch: {
        alert(val) {
            if (val) {
                this.$refs.modalAlert.modalShow()
            } else {
                this.$refs.modalAlert.modalHide()
            }
        },
    },
};
</script>
